// extracted by mini-css-extract-plugin
module.exports = {"random-btn":"ComicContainer_random-btn__Jz7K-","sides":"ComicContainer_sides__23Orp"};